const SUPPORTED_PREVIEW_EXTENSIONS = ["doc", "docx", "pdf", "pdfx", "msg"];

export { SUPPORTED_PREVIEW_EXTENSIONS };
